import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import { BankAccountModel } from '../../../../modules/finanzas/bancos/bankaccount.model';

export interface BankAccountListFilter {
  page: number;
  pageSize: number;
  search?: string;
  sortField?: string;
  sortDirection?: string;
}

export interface BankAccountListSummary {
  count: number;
  totalBalance: number;
}

export interface BankAccountListResult {
  items: BankAccountModel[];
  total: number;
  summary: BankAccountListSummary;
}

export const EMPTY_BANK_ACCOUNT_SUMMARY: BankAccountListSummary = {
  count: 0,
  totalBalance: 0,
};

@Injectable({ providedIn: 'root' })
export class BankAccountReadService {
  private readonly baseUrl = `${environment.apiUrl}/api/v2/bank-accounts`;

  constructor(private http: HttpClient) { }

  list(filter: BankAccountListFilter): Promise<BankAccountListResult> {
    const fallback = 'No se pudo cargar la lista de cuentas bancarias';
    return firstValueFrom(this.http.post<any>(`${this.baseUrl}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
          summary: response.summary || { ...EMPTY_BANK_ACCOUNT_SUMMARY },
        };
      });
  }
}
